import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentIcon from "@mui/icons-material/Payment";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import FavoriteIcon from "@mui/icons-material/Favorite";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";

const english = {
  language: "english",
  devsthan: "Devsthan",

  profileInformaton: "Profile Information",

  //Home Page
  home: "Home",
  heading1: "Feel Closer to God, Wherever Life Takes You!",
  subHeading1:
    "From Rituals to Reflection, Your Partner in Every Spiritual Need",
  heading2: "Upcoming Puja & Chadhawa",
  subHeading2:
    "Book Pujas at renowned temples in India for divine blessings, ritual videos, and tirth Aashirwad box.",
  heading3: "Experience Divine Connection",
  heading4: "What Our Devotees Say",
  subHeading4:
    "Discover heartfelt testimonials from devotees about their divine experiences at Devsthan",
  heading5: "How Devsthan Works",
  subHeading5: "Rituals performed by highly trained vedic priests",
  menuItems: [
    {
      icon: "🚩",
      title: "🚩Select Puja/Chadhawa Seva",
      subtitle: "Choose your desired ritual.",
      image:
        "https://assets-manager-devsthan.s3.ap-south-1.amazonaws.com/how_devsthan_works/select_puja_or_chadawa.webp",
    },

    {
      // icon: InfoIcon,
      title: "🚩Select Package & Offerings",
      subtitle: "Pick a package and offerings.",
      image:
        "https://assets-manager-devsthan.s3.ap-south-1.amazonaws.com/how_devsthan_works/select_package_and_offerings.webp",
    },
    {
      // icon: VideocamIcon,
      title: "🚩Share Name & Gotra",
      subtitle: "Provide details for booking.",
      image:
        "https://assets-manager-devsthan.s3.ap-south-1.amazonaws.com/how_devsthan_works/share_name_and_gotra.webp",
    },
    {
      // icon: LocalShippingIcon,
      title: "🚩Receive Aashirwad box & Video",
      subtitle: "Get Aashirwad box and Puja recording.",
      image:
        "https://assets-manager-devsthan.s3.ap-south-1.amazonaws.com/how_devsthan_works/receive_prasad_and_video.webp",
    },
    {
      // icon: LocalShippingIcon,
      title: "🚩Experience Divine Blessings",
      subtitle: "Feel spiritual fulfillment.",
      image:
        "https://assets-manager-devsthan.s3.ap-south-1.amazonaws.com/how_devsthan_works/experience_divine_blessings.webp",
    },
  ],
  importantDetails: [
    {
      id: 1,
      title: "🚩 Vedic Rituals by trained priests",
      description: "Rituals performed by highly trained vedic priests",
    },
    {
      id: 2,
      title: "🕉️ Watch Puja Video Recordings",
      description: "Feel connected through video of puja seva",
    },
    {
      id: 3,
      title: "📦 Aashirwad box Home Delivery",
      description: "Receive sacred Aashirwad box within 7 days",
    },
    {
      id: 4,
      title: "📹 Accessible Anytime, Anywhere",
      description: "Feel the Divine, Every Moment of Your Existence",
    },
  ],

  //Puja Listing Page
  heading6: "Upcoming Pujas",

  //Chadawa Page
  heading8: "Offering Chadhawa",

  //Particular Puja Page & Particular Chadawa Page
  shareButton: "Share",
  participateNow: "Participate Now",
  closesIn: "Closes in",
  bookChadawa: "Book Chadhawa",
  offerChadawa: "Offer Chadhawa",
  waysToParticipate: "Select Puja Package",
  selectPackage: "Select Package",
  eventEnded: "The event has ended!",
  eventUpcoming: "The event is upcoming. Stay tuned!",
  aboutPuja: "About Puja",
  aboutChadawa: "About Chadhawa",
  benefits: "Benefits",
  about: "About",
  faq: "FAQ",
  participate: "Participate",
  offer: "Offer",
  pujaBenefitsHeading: "Benefits of Puja",
  chadawaBenefitsHeading: "Benefits of Chadhawa",
  pujaBenefitsSubHeading:
    "Discover how Devsthan transforms your spiritual journey with trusted guidance, live rituals, sacred Aashirwad box delivery, and access to India's most revered temples—anytime, anywhere.",
  chadawaBenefitsSubHeading:
    "Discover how Devsthan transforms your spiritual journey with trusted guidance, live rituals, sacred Aashirwad box delivery, and access to India's most revered temples—anytime, anywhere.",
  pujaInformation: [
    {
      id: 1,
      icon: <AccessTimeIcon />,
      title: "Select Puja Seva",
      description: "Choose the package for Puja.",
    },
    {
      id: 2,
      icon: <AssignmentIcon />,
      title: "Provide Sankalp Details",
      description: "Enter your Name and Gotra for blessings.",
    },
    {
      id: 3,
      icon: <LocalShippingIcon />,
      title: "Add Aashirwad box Home Delivery (Optional)",
      description: "Get Aashirwad box delivered to your doorstep.",
    },
    {
      id: 4,
      icon: <PaymentIcon />,
      title: "Make Payment",
      description: "Securely complete your booking online.",
    },
    {
      id: 5,
      icon: <EventAvailableIcon />,
      title: "Puja Seva Conducted as per Muhurat",
      description: "Puja performed at the most auspicious time.",
    },
    {
      id: 6,
      icon: <VideoLibraryIcon />,
      title: "Puja Video & Ashirwad Box",
      description: "Receive a personalized video and blessings.",
    },
    {
      id: 7,
      icon: <FavoriteIcon />,
      title: "Feel the Divine Blessings",
      description: "Experience peace and positivity.",
    },
  ],
  chadawaInformation: [
    {
      id: 1,
      icon: <AccessTimeIcon />,
      title: "Select Chadhawa",
      description:
        "Please choose a puja type from the following four options: Individual, Couple, Family, or Joint Family.",
    },
    {
      id: 2,
      icon: <WorkOutlineOutlinedIcon />,
      title: "Enter your Basic details:",
      description:
        "Please provide your basic information to facilitate the processing of your application.",
    },
    {
      id: 3,
      icon: <DescriptionOutlinedIcon />,
      title: "Make a payment:",
      description:
        "Upon successful payment, you will receive a confirmation receipt.",
    },
    {
      id: 4,
      icon: <ViewInArOutlinedIcon />,
      title: "Enter your Name and Gotra",
      description:
        "To personalize your puja, please provide your Ancestor and Gotra names.",
    },
    {
      id: 5,
      icon: <PersonOutlineOutlinedIcon />,
      title: "Enjoy your personalise Video",
      description: "We appreciate your participation in the Live Puja.",
    },
    {
      id: 6,
      icon: <WorkspacePremiumOutlinedIcon />,
      title: "Aashirwad box Shipped within 1 Week",
      description:
        "Your puja will be delivered within one week of the scheduled date.",
    },
  ],

  //Cart Page
  reviewBooking: "Review Booking",
  bookingSummary: "Booking Summary",
  packageType: "Package Type",
  enterDetails: "Enter your details",
  fullName: "Full Name",
  gotra: "Gotra",
  whatsappNumber: "WhatsApp Number",
  addPrasad: "Add Aashirwad box",
  address: "Address",
  city: "City",
  state: "State",
  pincode: "Pincode",
  additionalName: "Additional Name",
  next: "Next",
  basicDetails: "Details",
  payment: "Payment",
  confirmation: "Confirmation",
  totalPrice: "Total Price:",
  //placeholders
  namePlaceholder: "Enter your full name",
  numberPlaceholder: "Enter your WhatsApp number",
  gotraPlaceholder: "Enter your gotra",
  addressPlaceholder: "Enter your address",
  cityPlaceholder: "Enter your city",
  statePlaceholder: "Enter your state",
  pincodePlaceholder: "Enter your pincode",
  additionalNamePlaceholder: "Enter additional name",

  //Order Details Page
  orderDate: "Order Date",
  orderType: "Order Type",
  orderStatus: "Order Status",
  totalAmount: "Total Amount",
  devoteName: "Devote Name",
  quantity: "Quantity",
  subtotal: "Subtotal",
  items: "Items",
  noItems: "No items in the cart",
  deliveryAddress: "Delivery Address",
  delivery: "Delivery",
  noPrasad: "You did not opt for Aashirwad box in this order.",
  paymentMethod: "Payment Method",
  paymentId: "Payment ID",
  paymentStatus: "Payment Status",
  total: "Total",
  noPayment: "We have not received your payment.",
  noBrowserSupport: "Your browser does not support the video tag.",
  pujaInProcess: "Your puja is in process.",
  oncePujaCompleted: "Once completed, your video will be available here.",
  viewMoreOrders: "View More Orders",
  orderDatePending: "Order Date is pending",
  devoteeNamePending: "Devotee Name is pending",
  notAvailable: "Not Available",
  //Sections labels
  summary: "Summary",
  shipping: "Shipping",
  tracking: "Tracking",
  Payment: "Payment",

  //All Orders Page
  yourBookings: "Your Bookings",
  bookingId: "Booking ID",
  payNow: "PAY NOW",
  details: "DETAILS",
  noMore: "No more bookings to load",
  bookingHeading: "Booking details and information",
  created: "Created",

  watchPujaNow: "Watch Your Puja Now",
  pujaWillBeDoneOn: "Your puja will be done on {date}",
  pujaVideoAvailable: " Your puja video will be available in 4-6 days",
  pujadate: "Puja Date",
  pujadatepending: "Puja Date is pending",
  paymentPending: "Payment is still pending. Please proceed with the payment.",

  //Deactivate Account Page
  accountDeactivationRequestReceived: "Account Deactivation Request Received",
  thankYou: "Thank you for being part of our community.",
  willBeDeactivated : "Your account will be deactivated in 24-48 hours.",
  redirectingToHomepage: "Redirecting to homepage",
  deactivateYourAccount: "Deactivate Your Account",
  sorryToSeeYouGo: "We're sorry to see you go. Deactivating your account will:",
  disableAccessToPlatform: "Disable your access to the platform.",
  removePersonalPreferences: "Permanently remove your personal preferences.",
  whyleaving: "Please tell us why you're leaving *",
  feedback: "Your feedback helps us improve our services",
  iUnderstandDeactivationIsPermanent:
    "I understand that deactivating my account is permanent and cannot be undone.",
  cancel: "Cancel",
  processing: "Processing...",
  deactivateMyAccount: "Deactivate My Account",

  //FAQ Section
  heading7: "Frequently Asked Questions",
  subHeading7:
    "Over 200 sacred rituals at renowned shrines offer a live Puja experience each month.",

  //Buttons
  puja: "Puja",
  chadawa: "Chadhawa",
  bookings: "Bookings",
  bookPuja: "Book Puja",
  exploreChadawa: "Explore Chadhawa",
  logout: "Logout",

  //footer
  footerHeading: "Get in Touch",
  footerSubHeading:
    "We'd love to hear from you! Reach out to us for any queries or feedback.",
};
export default english;
